import { getVideoMetadataValue } from '../../../../tools/utils';

export const getShowSeasonEpisodeHeader = (video) => {
    const showTitle = video.showData.gist.title || '';
    const seasonTitle = video.showData.seasons[video.currentSeason].title || '';
    const episodeTitle = video.title || '';
    return `${showTitle + ' - '}${seasonTitle + ' - '}${episodeTitle}`;
}

export const getShowSeasonNextEpisodeHeader = (video) => {
    const showTitle = video.showData.gist.title || '';
    const seasonTitle = video.nextEpisode.gist.seasonTitle || '';
    const episodeTitle = video.nextEpisode.gist.title || '';
    return `${showTitle + ' - '}${seasonTitle + ' - '}${episodeTitle}`;
}

export const convertNumberToTime = (num) => {
    let minutes = Math.floor(num / 60);
    let seconds = num % 60;
    minutes = minutes > 9 ? minutes.toString() : '0' + minutes.toString();
    seconds = seconds > 9 ? seconds.toString() : '0' + seconds.toString();
    return `${minutes}:${seconds}`
}

/**
 * assemble repeat x times label
 * @param {Object} video 
 * @param {string} repeatLabel 
 * @param {string} timesLabel 
 */
export const getRepeatTime = (video, repeatLabel, timesLabel) => {
    const repeatTime = getVideoMetadataValue(video, 'repeatTime', '');
    return `${repeatLabel} ${repeatTime} ${timesLabel}`;
}